export default __webpack_public_path__ + "static/media/mvoult-logo-dark.a6dd1cef.png";